import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import { required, email, minLength } from "vuelidate/lib/validators";
import store from "@/store";
import axios from "axios";

export default {
    name: "applicantLogin",
    components: {
        MainLayout,
    },

    data() {
        return {
            loginForm: {
                email: this.email,
                password: this.password
            },
            submitted: false,
            error_email: ""
            // applicantToken: localStorage.getItem("APPLICANT_AUTH_TOKEN")
        };
    },

    validations: {
        loginForm: {
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(6)
            }
        }
    },

    methods: {
        submitLogin() {
            this.submitted = true;
            if (this.$v.loginForm.$invalid) {
                return;
            }
            this.loginApplicant();
        },

        loginApplicant() {
            store.dispatch("applicantLogin", {
                    email: this.loginForm.email,
                    password: this.loginForm.password,
                })
                .then(() => {
                    this.$router.push({
                        name: "homeIndex"
                    });
                })
                .catch(error => {
                    this.$notification.error("သင့် အီးမေးလ်လိပ်စာနှင့် စကားဝှက်ကို ပြန်လည်စစ်ဆေးပေးပါ။", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log("login error", error);
                });
        },

        AuthProvider(provider) {
            this.$auth.authenticate(provider)
                .then(response => {
                    this.facebookLogin(provider, response);
                    console.log(response, "response");
                })
                .catch(err => {
                    console.log({
                        err: err
                    });
                });
        },

        facebookLogin(provider, response) {
            axios.post('/applicant/facebooklogin/' + provider, response)
                .then(response => {
                    if (response.data.data.token) {
                        store.commit("setApplicantData", response.data.data);
                        this.$router.push({
                            name: 'homeIndex'
                        });
                        location.reload();
                    } else {
                        this.$router.push({
                            name: "applicantRegister",
                            params: {
                                data: response.data.data
                            }
                        });
                        this.$notification.success("Please Signup First", {
                            timer: 2,
                            position: "bottomCenter"
                        });
                    }
                })
                .catch(error => {
                    console.log("Facebook Login Error", error);
                });
        }
    },

    mounted() {
        const email = localStorage.getItem('loginEmail')
        if (email != 'undefined') {
            this.loginForm.email = email;
        } else this.loginForm.email = null;
    }
};
